import { Button, type ButtonVariant } from '@/components/common/button';

import styles from './overlay-chrome.module.scss';

export type OverlayFooterProps = {
  primaryText?: string;
  onPrimary?: () => void;
  /** When true the primary button is `type="submit"` (used by FormModal/FormDrawer). */
  isSubmit?: boolean;
  primaryVariant?: ButtonVariant;
  primaryDanger?: boolean;
  loading?: boolean;
  disabled?: boolean;
  cancelText?: string;
  onCancel?: () => void;
  align?: 'end' | 'center';
};

export function OverlayFooter({
  primaryText,
  onPrimary,
  isSubmit = false,
  primaryVariant = 'primary',
  primaryDanger = false,
  loading = false,
  disabled = false,
  cancelText = 'Cancel',
  onCancel,
  align = 'end',
}: OverlayFooterProps) {
  const showCancel = Boolean(cancelText && onCancel);
  if (!primaryText && !showCancel) return null;

  return (
    <div className={[styles.footer, align === 'center' ? styles.footerCenter : ''].join(' ')}>
      {showCancel ? (
        <Button variant="secondary" onClick={onCancel} disabled={loading}>
          {cancelText}
        </Button>
      ) : null}
      {primaryText ? (
        <Button
          htmlType={isSubmit ? 'submit' : 'button'}
          variant={primaryVariant}
          onClick={isSubmit ? undefined : onPrimary}
          loading={loading}
          disabled={disabled}
          className={primaryDanger ? styles.danger : undefined}
        >
          {primaryText}
        </Button>
      ) : null}
    </div>
  );
}
